/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Building_Access_Suspended_Admin_MessageInputs */



/**
* | output |
* | --- |
* | "Your access is suspended due to a payment error. To regain access, please contact the Eisox team." |
*
* @param {Building_Access_Suspended_Admin_MessageInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const building_access_suspended_admin_message = /** @type {((inputs?: Building_Access_Suspended_Admin_MessageInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Building_Access_Suspended_Admin_MessageInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Your access is suspended due to a payment error. To regain access, please contact the Eisox team.")
	return /** @type {LocalizedString} */ ("Votre accès est suspendu en raison d’une erreur de paiement. Pour y accéder de nouveau nous vous invitons à vous rapprocher des équipes Eisox.")
});